import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Link } from 'react-router-dom';

const Form = (props) => {
    const {
        getRootProps,
        getInputProps
    } = useDropzone({
        multiple: false,
        accept: 'image/*',
        onDrop: (files) => {
            props.setFile(files[0]);
        }
    });

    if (props.actionType === 'list') {
        return null;
    }

    if (props.fetchingElement) {
        return (
            <div className="form-container">
                <div className="loading-container">
                    <i className="fas fa-circle-notch fa-spin" /> Loading data...
                </div>
            </div>
        );
    }

    let selectedFileContainer = null;
    if (props.file && props.file != null) {
        selectedFileContainer = (
            <div className="selected-file-container">
                <strong>Selected file:</strong> {props.file.name}
            </div>
        );
    }

    const handleSetField = (field, event) => {
        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        props.setField(field, value);

        if (field === 'type') {
            props.setField('uthealth_department_id', '');
        }
    };

    let previewImage = null;
    if (props.item.image_url != null) {
        previewImage = (
            <div className="preview-image">
                <div>Current image:</div>
                <img src={props.item.image_url} alt={props.item.name} />
            </div>
        );
    }

    const renderCategories = () => {
        let options = [];
        for (let i = 0; i < props.information.parentCategories.length; i++) {
            const element = props.information.parentCategories[i];

            if (parseInt(props.item.type) === parseInt(element.type)) {
                if (element.platform === '') {
                    continue
                }

                options.push(<option value={element.id}>[{element.platform}] {element.name}</option>);
                renderSubcategories(element, options, 1);
            }
        }

        return options;
    };

    const renderSubcategories = (element, options, level) => {
        let spaces = [];
        for (let i = 0; i < level; i++) {
            spaces.push('&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;');
        }

        for (let i = 0; i < element.subcategories.length; i++) {
            const subcategory = element.subcategories[i];
            options.push(<option value={subcategory.id} dangerouslySetInnerHTML={{
                __html: spaces.join('') + subcategory.name
              }}></option>);
              
            renderSubcategories(subcategory, options, level + 1);
        }
    };

    return (
        <div className="form-container">
            <div className="fields">
                <div className="field">
                    <div className="label">Name <span className="required">*</span>:</div>
                    <input type="text" value={props.item.name} onChange={handleSetField.bind(this, 'name')} placeholder="Name" />
                </div>
                <div className="field">
                    <div className="label">Type <span className="required">*</span>:</div>
                    <select value={props.item.type} onChange={handleSetField.bind(this, 'type')}>
                        <option value="">Select option</option>
                        <option value="1">Forms</option>
                        <option value="2">Apparel</option>
                    </select>
                </div>
                <div className="field">
                    <div className="label">Parent Category <span className="required">*</span>:</div>
                    <select value={props.item.uthealth_department_id} onChange={handleSetField.bind(this, 'uthealth_department_id')}>
                        <option value="">None</option>
                        {renderCategories()}
                    </select>
                </div>
                <div className="field">
                    <div className="label">Active <span className="required">*</span>:</div>
                    <select value={props.item.active} onChange={handleSetField.bind(this, 'active')}>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
                <div className="field">
                    <div className="label">Show for UTP <span className="required">*</span>:</div>
                    <select value={props.item.allow_utp} onChange={handleSetField.bind(this, 'allow_utp')}>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
                <div className="field">
                    <div className="label">Show for UTH <span className="required">*</span>:</div>
                    <select value={props.item.allow_uth} onChange={handleSetField.bind(this, 'allow_uth')}>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
                <div className="field">
                    <div className="label">Show for Coupa <span className="required">*</span>:</div>
                    <select value={props.item.allow_coupa} onChange={handleSetField.bind(this, 'allow_coupa')}>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
                <div className="field">
                    <div className="label">Show for Personal <span className="required">*</span>:</div>
                    <select value={props.item.allow_personal} onChange={handleSetField.bind(this, 'allow_personal')}>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
                <div className="field">
                    <div className="label">Image (Recommended size: 400x400 px):</div>
                    <div {...getRootProps({ className: 'dropzone-container' })}>
                        <input {...getInputProps()} />
                        <button className="browse-files-button admin-button">Select File</button>
                    </div>
                    {selectedFileContainer}
                    {previewImage}
                </div>
            </div>
            <div className="buttons-container">
                <div className="button-container">
                    <Link to="/admin/departments">
                        <button className="cancel-button">Cancel</button>
                    </Link>
                </div>
                <div className="button-container">
                    <button className="save-button" onClick={props.saveElement} disabled={props.saving}>
                        {props.saving ? <i className="fas fa-circle-notch fa-spin" /> : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Form;
